import React from 'react';
import { ConfirmDialog } from '@personal-dashboard/ui';

interface DeleteCustomFieldSectionDialogProps {
  open: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteCustomFieldSectionDialog: React.FC<DeleteCustomFieldSectionDialogProps> = ({
  open,
  loading,
  onConfirm,
  onCancel,
}) => {
  return (
    <ConfirmDialog
      open={open}
      title="Delete Field Section"
      message="Are you sure you want to delete this field section? This will lose any unsaved changes."
      confirmLabel="Delete"
      severity="error"
      loading={loading}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default DeleteCustomFieldSectionDialog;
